<div class="flex-container-column full-width">
    <curafida-card
        [title]="'MAIN_CONFIGURATION'"
        class="full-width">
        <ion-card-content>
            @if (formUserPreferences && resource) {
                <form [formGroup]="formUserPreferences">
                    @if (user().roles.includes(UserRoles.PATIENT)) {
                        <curafida-select-input
                            [isMobile]="isMobile()"
                            [formControlName]="'currentMode'"
                            [formGroup]="formUserPreferences"
                            [itemList]="patientMode"
                            [label]="'Ansicht'">
                        </curafida-select-input>
                    } @else {
                        <div class="flex-container-row full-width">
                            <ion-label
                                class="half-width item-label-profil bold ion-label-color-disabled ion-padding-top"
                                >{{ 'MODULE.PLURAL' | translate }}
                            </ion-label>
                            <div
                                [class.ion-item-box-disable]="!isEditEnabled"
                                [class.ion-item-box-enable]="isEditEnabled"
                                class="flex-container-column item-input-width ion-item-box text-standard-input-size">
                                <ion-item
                                    class="full-width"
                                    lines="none">
                                    <ion-checkbox
                                        (ionChange)="formUserPreferences.markAsDirty()"
                                        [checked]="formUserPreferences.controls['course'].value"
                                        [formControlName]="'course'"
                                        labelPlacement="end"
                                        style="margin-right: 32px"
                                        >{{ 'Kurse' | translate }}
                                    </ion-checkbox>
                                </ion-item>
                            </div>
                        </div>
                    }
                    <div
                        [class.flex-container-row]="userPreferencesService.userPreferences().currentMode !== 'MINI'"
                        [class.flex-container-column]="userPreferencesService.userPreferences().currentMode === 'MINI'">
                        <ion-label class="half-width item-label-profil bold ion-padding-top"
                            >{{ 'FONT_SIZE' | translate }}
                        </ion-label>
                        <div
                            [class.half-width]="userPreferencesService.userPreferences().currentMode !== 'MINI'"
                            [class.full-width]="userPreferencesService.userPreferences().currentMode === 'MINI'"
                            [class.ion-margin-horizontal]="
                                userPreferencesService.userPreferences().currentMode !== 'MINI'
                            "
                            class="flex-container-column">
                            <div class="full-width item-label-profil">
                                <ion-range
                                    [formControlName]="'fontSize'"
                                    [formGroup]="formUserPreferences"
                                    (ionChange)="changeTextSize($event)"
                                    class="range-profile"
                                    max="16"
                                    min="12"
                                    pin="true"
                                    snaps="true"
                                    step="2"
                                    ticks="true"
                                    data-test-id="font-size-range-3d614037"></ion-range>
                            </div>
                            <div class="flex-container-row justify-content-space-between full-width item-label-profil">
                                <p>Klein</p>
                                <p>Normal</p>
                                <p>Groß</p>
                            </div>
                        </div>
                    </div>
                </form>
                <curafida-save-cancel-button
                    (saveInformationEmit)="saveForm()"
                    (cancelEditEmit)="cancelForm()"
                    (toggleEditEmit)="toggleEdit()"
                    [element]="resource"
                    [formGroup]="formUserPreferences"
                    [isEditEnabled]="isEditEnabled"></curafida-save-cancel-button>
            }
        </ion-card-content>
    </curafida-card>
</div>
